import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/512c25b6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Structured list`}</h2>
    <ComponentCode name="Structured list" component="structured-list" variation="structured-list" hasReactVersion="structuredlist--simple" hasVueVersion="structuredlist--default" hasAngularVersion="?path=/story/structured-list--basic" codepen="oOxYoE" mdxType="ComponentCode"></ComponentCode>
    <h2>{`Structured list with selection`}</h2>
    <ComponentCode name="Structured list with selection" component="structured-list" variation="structured-list--selection" hasReactVersion="structuredlist--selection" hasVueVersion="structuredlist--selectable-with-vmodel" hasAngularVersion="?path=/story/structured-list--with-selection" codepen="NmNbyK" mdxType="ComponentCode"></ComponentCode>
    <h2>{`Documentation`}</h2>
    <ComponentDocs component="structured-list" mdxType="ComponentDocs"></ComponentDocs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      